// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".system-user {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 100%;\n}\n.system-user .List-header {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 12px 0;\n}\n.system-user .MesTable-wrap {\n  height: calc(100% - 140px);\n}", ""]);
// Exports
module.exports = exports;
